import { Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"

import { useFindOrganizationById } from "~/gen/api/hooks"

export const OrganizationDetailsWrapper = () => {
  const { t } = useTranslation("admin")

  const params = useParams()
  const organizationId = params.organizationId ?? ""

  const { data: organizationQuery } = useFindOrganizationById(organizationId)

  const pages = useMemo<PageLink[]>(
    () => [
      {
        label: t("tabs.general"),
        link: "general",
      },
      {
        label: t("tabs.featureAccess", { defaultValue: "Feature access" }),
        link: "feature-access",
      },
      {
        label: t("tabs.invoices"),
        link: "invoices",
      },
    ],
    [t]
  )

  if (!organizationQuery?.data) return null

  return (
    <Page
      title={organizationQuery?.data?.name}
      pages={pages}
      data={organizationQuery?.data}
    />
  )
}
